module.exports = __webpack_public_path__ + "img/b4.14b1523.png";